export enum SalesEnablementEventTypes {
  IS_CHECKOUT_PAGE = 'DXP_IS_CHECKOUT_PAGE',
  REQUEST_SESSION_ID = 'DXP_REQUEST_SE_SESSION_ID',
  SESSION_ID = 'DXP_SE_SESSION_ID',
  RELOAD_DEAL = 'DXP_RELOAD_DEAL',
  IS_DEAL_EXPORTED = 'DXP_IS_DEAL_EXPORTED',
}
